import moment from "moment"

/**
 * Bounds the reporting backend accepts (see shared/reportValidators.ts).
 * Keeping the UI in sync means a half-typed year never leaves the browser —
 * LOCKER-331, where `0000-07-10` reached Postgres and returned a raw 500.
 */
export const REPORT_MIN_DATE = moment("2000-01-01", "YYYY-MM-DD")
export const REPORT_MAX_DATE = moment("2100-12-31", "YYYY-MM-DD")

/**
 * A date picker reports a year-0 date as "valid" while the user is still
 * typing the year, so `moment.isValid()` alone is not enough of a guard.
 */
export const isValidReportDate = (
  date: moment.Moment | null | undefined,
): date is moment.Moment =>
  !!date &&
  date.isValid() &&
  date.isBetween(REPORT_MIN_DATE, REPORT_MAX_DATE, "day", "[]")

export const getDateFormat = (period: string) => {
  switch (period) {
    case "year":
    case "month":
    case "week":
    case "day":
      return "YYYY-MM-DD"
    case "hour":
      return "YYYY-MM-DD HH:mm:ss"
    default:
      return "YYYY-MM-DD"
  }
}

export const truncateDate = (date: moment.Moment, period: string) => {
  switch (period) {
    case "year":
      return date.startOf("year")
    case "month":
      return date.startOf("month")
    case "week":
      return date.startOf("week")
    case "day":
      return date.startOf("day")
    case "hour":
      return date.startOf("hour")
    default:
      return date
  }
}
